const optionsKey = "matpower:/data/options";

const OptionStore = {
  data: {
    options: {
      model: "AC",
      pf: {
        alg: "NR",
        current_balance: 0,
        v_cartesian: 0,
        tol: 1e-8,
        nr: {
          max_it: 10
        },
        fd: {
          max_it: 30
        },
        enforce_q_lims: 0
      },
      opf: {
        current_balance: 0,
        v_cartesian: 0,
        violation: 5e-6,
        flow_lim: "S",
        ignore_angle_lim: 0,
        start: 0
      },
      verbose: 2
    }
  },
  methods: {
    loadOptions() {
      let data = localStorage.getItem(optionsKey);
      if (data) {
        OptionStore.methods.setOptions(JSON.parse(data));
      }
    },
    saveOptions() {
      let data = JSON.stringify(OptionStore.methods.getOptions());
      if (data) {
        localStorage.setItem(optionsKey, data);
      }
    },
    getOptions() {
      return OptionStore.data.options;
    },
    setOptions(options) {
      OptionStore.data.options = options;
    }
  }
};

export default OptionStore;
